






















import { computed, defineComponent } from "@vue/composition-api";
import { MessageAttachment } from "@scrile/api-provider/dist/api/MessagesProvider";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "MessageMediaItemStatus",
  components: { BaseIcon },
  props: {
    attachment: { type: Object as () => MessageAttachment, required: true },
    isAuthor: { type: Boolean, required: true },
    multipleFiles: { type: Boolean, default: false },
  },
  setup(props) {
    const processing = computed(() => props.attachment.file.processingStatus !== "OK");
    const error = computed(() => props.attachment.file.processingStatus === "ERROR");

    return { processing, error };
  },
});
